import PrintDialog from './PrintDialog';
import reducer from './reducer';

export { reducer };
export default PrintDialog;
